import { Link, useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { api } from "../api/client";
import { formatMoney, formatDate } from "../lib/format";
import { EstimateTable, Stat } from "../components/EstimateTable";

export function ClaimantProfile() {
  const { oid = "" } = useParams();
  const profile = useQuery({ queryKey: ["claimant", oid], queryFn: () => api.claimantProfile(oid) });

  if (profile.isLoading) return <div className="text-slate-500">Loading...</div>;
  if (profile.error)     return <div className="text-red-600">{(profile.error as Error).message}</div>;
  if (!profile.data)     return <div className="text-slate-500">Not found.</div>;

  const p = profile.data.profile;
  const k = profile.data.kpis ?? {};
  const estimates: any[] = profile.data.estimates ?? [];

  return (
    <div className="space-y-6">
      <div className="flex items-baseline justify-between">
        <div>
          <h1 className="text-2xl font-semibold text-liaise-navy">{p?.displayName ?? p?.userPrincipalName ?? oid}</h1>
          <div className="text-sm text-slate-500 mt-1">
            {p?.userPrincipalName ?? "-"}
            {p?.jobTitle && <span> · {p.jobTitle}</span>}
            {p?.department && <span> · {p.department}</span>}
          </div>
        </div>
        <Link to="/all-estimates" className="text-sm text-slate-500 hover:underline">← Back</Link>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-5 gap-3">
        <Stat label="Total" value={String(k.total ?? 0)} />
        <Stat label="Drafts" value={String(k.drafts ?? 0)} />
        <Stat label="Submitted" value={String(k.submitted ?? 0)} highlight={(k.submitted ?? 0) > 0} />
        <Stat label="Approved" value={String(k.approved ?? 0)} />
        <Stat label="Approved £" value={formatMoney(k.approved_value)} />
      </div>

      {k.first_submission_at && (
        <div className="text-xs text-slate-500">
          First submission {formatDate(k.first_submission_at)}, last on {formatDate(k.last_submission_at)}.
        </div>
      )}

      <div className="bg-white rounded-2xl shadow-sm border border-slate-200 overflow-hidden">
        <div className="px-6 py-3 border-b border-slate-100 text-sm font-semibold text-liaise-navy">Estimate history</div>
        <EstimateTable rows={estimates} hide={["claimant"]} />
      </div>
    </div>
  );
}
